import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../utils/api.services";

export const UserRegister = createAsyncThunk("userPermission", async (submitData, { rejectWithValue }) => {
    try {
        const { data } = await API.Register(submitData);
        
        return data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const UsersendOtp = createAsyncThunk("userPermission", async (submitData, { rejectWithValue }) => {
    try {
        const { data } = await API.SendOtp(submitData);
        
        return data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const initialState = {
    user: null,
    error: null,
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(UserRegister.fulfilled, (state, action) => {
                state.user = action.payload;
                state.error = null;
            })
            .addCase(UserRegister.rejected, (state, action) => {
                state.error = action.payload;
                state.user = null;
            });

         
    },
});

export default userSlice.reducer;
